import * as React from 'react'
import {graphql} from 'gatsby'
import {withPrismicPreview} from 'gatsby-plugin-prismic-previews'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import RenderRichText from 'src/utils/renderRichText'
import useSlice from 'src/hooks/useSlice'
import Contact from 'src/components/templates/ContactPage'
import {ContactDocument} from '../../types.generated'
import {Location, Phone, EmailTick} from 'src/assets/icons'

interface Props {
  data: {
    prismicContact: ContactDocument
  }
}

const ContactPage = ({data}: Props) => {
  const hero = useSlice(data.prismicContact, 'hero')
  const contact = useSlice(data.prismicContact, 'contact')
  return (
    // <div>text</div>
    <Contact
      heroContent={() => (
        <>
          <RenderRichText
            field={hero.primary.hero_title}
            components={{
              heading1: ({children}) => (
                <Typography variant="h3" component="h1" gutterBottom>
                  {children}
                </Typography>
              ),
            }}
          />
          <Box sx={{mb: 4}}>
            <RenderRichText field={hero.primary.hero_text} />
          </Box>
        </>
      )}
      contactGrid={() => (
        <Grid container spacing={3} sx={{mb: 4}}>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{
                textAlign: 'center',
                minHeight: {
                  xs: 0,
                  md: 350,
                },
              }}
            >
              <CardContent>
                <EmailTick />
                <Typography
                  variant="h5"
                  component="h2"
                  gutterBottom
                  sx={{mt: 2}}
                >
                  Email
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  gutterBottom
                  sx={{fontWeight: '500'}}
                >
                  {contact.primary.email.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{
                textAlign: 'center',
                minHeight: {
                  xs: 0,
                  md: 350,
                },
              }}
            >
              <CardContent>
                <Location />
                <Typography
                  variant="h5"
                  component="h2"
                  gutterBottom
                  sx={{mt: 2}}
                >
                  Location
                </Typography>
                <RenderRichText
                  field={contact.primary.address}
                  components={{
                    paragraph: ({children}) => (
                      <Typography
                        variant="subtitle1"
                        component="p"
                        sx={{fontWeight: '500'}}
                      >
                        {children}
                      </Typography>
                    ),
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card
              variant="outlined"
              sx={{
                textAlign: 'center',
                minHeight: {
                  xs: 0,
                  md: 350,
                },
              }}
            >
              <CardContent>
                <Phone />
                <Typography
                  variant="h5"
                  component="h2"
                  gutterBottom
                  sx={{mt: 2}}
                >
                  Phone Number
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  sx={{fontWeight: '500'}}
                >
                  {contact.primary.phone.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    />
  )
}

export const query = graphql`
  {
    prismicContact {
      _previewable
      data {
        body {
          ... on PrismicContactDataBodyHero {
            primary {
              hero_text {
                richText
              }
              hero_title {
                richText
              }
            }
            slice_type
          }
          ... on PrismicContactDataBodyContact {
            primary {
              phone {
                text
              }
              email {
                text
              }
              address {
                richText
              }
            }
            slice_type
          }
        }
      }
    }
  }
`

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default withPrismicPreview(ContactPage)
